// extracted by mini-css-extract-plugin
module.exports = {"dialogIframeWrapper":"googlePay3DSecureModal_dialogIframeWrapper__8egnP","dialogIframe":"googlePay3DSecureModal_dialogIframe__1bgUI"};